import { render, staticRenderFns } from "./RolePicker.vue?vue&type=template&id=da2a0ac6&scoped=true"
import script from "./RolePicker.vue?vue&type=script&lang=js"
export * from "./RolePicker.vue?vue&type=script&lang=js"
import style0 from "./RolePicker.vue?vue&type=style&index=0&id=da2a0ac6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2a0ac6",
  null
  
)

export default component.exports